<div class="page-container account-linking-container container">
  <app-breadcrumb [crumbConfig]="crumbConfig" />

  @if (directAccountId === '') {
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    />
  } @else {
    <app-account-linking-detail [directAccountId]="directAccountId" />
  }
</div>
